/**
 * Helper function to determine if a link is external
 * @param {string} href - The link href
 * @returns {boolean} - True if external link
 */
export const isExternalLink = (href) => {
  return href.startsWith('http://') || href.startsWith('https://') || href.startsWith('mailto:') || href.startsWith('tel:');
};

/**
 * Helper function to get link props for external links
 * @param {Object} link - The link object
 * @returns {Object} - Props to spread onto anchor element
 */
export const getLinkProps = (link) => {
  const external = isExternalLink(link.href);

  if (external && !link.sameWindow) {
    return {
      target: '_blank',
      rel: 'noopener noreferrer',
    };
  }

  return {};
};
